import { appEventTypes } from "@src/common/events/AppEventTarget";

class ShowConnectorTooltipEvent extends CustomEvent<null> {
  constructor() {
    super(appEventTypes.SHOW_CONNECTOR_TOOLTIP);
  }
}

export default ShowConnectorTooltipEvent;
